import React from 'react';
import { SignalRContext } from 'src';
import { getValidNotificationTypes, NotificationDataSummary } from 'src/stores/notifications-store';
import { useSessionNotifications } from './notifications-session-store';

export const NotificationsReceiver = () => {
  const sessionNotifications = useSessionNotifications();
  const { useSignalREffect } = SignalRContext;
  const validNotifications = getValidNotificationTypes();

  useSignalREffect(
    'ReceiveNotification',
    (notification: NotificationDataSummary) => {
      if (validNotifications.includes(notification.type)) sessionNotifications.addUnreadNotification(notification);
    },
    []
  );

  useSignalREffect('UnreadCountUpdated', (count: number) => {}, []);

  return <></>;
};
